module.exports = __webpack_public_path__ + "static/media/Pz1a.3cd8fdc2.jpg";